import { EditCommand } from "./EditCommand";

export abstract class AbstractWriteValueCommand<TSource, TValue> extends EditCommand<TSource, TValue> {
  constructor(private readonly _value: TValue) {
    super(s => this.read(s), s => this.write(s, this._value), (s, b) => this.write(s, b));
  }

  protected abstract read(source: TSource): TValue;
  protected abstract write(source: TSource, value: TValue): void;
}
